import { render, staticRenderFns } from "./SearchName.vue?vue&type=template&id=623484cf&lang=true&"
import script from "./SearchName.vue?vue&type=script&lang=js&"
export * from "./SearchName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports